module.exports = __webpack_public_path__ + "img/ic_reset_successful.37c3a307.svg";